"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.error.profession_required': 'Por favor seleccione una profesión antes de continuar',
    'onboarding.error.profession_select_first': 'Por favor seleccione una profesión primero',
    'onboarding.error.avatar_name_required': 'El nombre del avatar es requerido',
    'onboarding.error.avatar_name_provide': 'Por favor proporcione un nombre para el avatar',
    'onboarding.error.answer_required': 'La respuesta es requerida',
    'onboarding.error.complete_required_step': 'Por favor complete el paso requerido',
    'onboarding.error.complete_step': 'Por favor complete el paso',
    'onboarding.error.before_finishing': 'antes de finalizar',
    'onboarding.error.professions_load_failed': 'Error al cargar las profesiones',
    'onboarding.error.professions_load_general': 'Error general al cargar las profesiones',
    'onboarding.error.steps_load_failed': 'Error al cargar los pasos',
    'onboarding.error.steps_load_general': 'Error general al cargar los pasos',
    'onboarding.error.questions_load_failed': 'Error al cargar las preguntas',
    'onboarding.error.questions_load_general': 'Error general al cargar las preguntas',
    'onboarding.error.load_failed': 'Error al cargar los datos de onboarding',
    'onboarding.error.load_general': 'Error general al cargar el onboarding',
    'onboarding.error.save_failed': 'Error al guardar el onboarding',
    'onboarding.error.save_general': 'Error general al guardar el onboarding',
};
